<template>
  <app-layout>

    <div class="h-full flex">
      <div class="flex flex-col w-0 flex-1">
        <main class="flex-1 relative focus:outline-none px-8">
          <bread-nav :pages="pages"></bread-nav>
          <div class="pt-8 pb-16">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
              <div>
                <update-billing-form :billing="billing">
                </update-billing-form>
              </div>
            </div>
            <div class="pt-8 pb-16 max-w-7xl mx-auto sm:px-6 lg:px-8">
              <div class="bg-white sm:rounded-lg shadow-sm divide-y divide-gray-100">
                <div class="flex items-center px-6 py-4" v-for="receipt in this.billing.receipts">
                  <div class="text-sm w-40">
                    {{ formatDate(receipt.paid_at) }}
                  </div>
                  <div class="ml-10 w-40 text-sm">
                    <span v-html="receipt.amount"></span>
                  </div>
                  <div class="ml-10">
                    <a class="underline text-sm text-gray-500" :href="receipt.receipt_url" target="_blank">View
                      Receipt</a>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </main>
      </div>
    </div>

  </app-layout>
</template>

<script>
import AppLayout from "@/Layouts/AppLayout";
import BreadNav from "@/Components/BreadNav/BreadNav";
import {ref} from 'vue';
import FormatsValues from './../../Mixins/FormatsValues';

const pages = [
  {name: 'Billing', href: '#', current: false},
  {name: 'Receipts', href: '#', current: true},
]

import JetConfirmationModal from '@/Jetstream/ConfirmationModal'
import JetDangerButton from '@/Jetstream/DangerButton'
import JetSecondaryButton from '@/Jetstream/SecondaryButton'
import {message} from "ant-design-vue";


import {
  UsersIcon,
  MailIcon,
} from "@heroicons/vue/outline";
import NoData from "@/Components/NoData/NoData";
import UpdateBillingForm from "@/Pages/Profile/UpdateBillingForm";

export default {
  mixins: [FormatsValues],
  props: [
    'billing'
  ],
  data() {
    return {};
  },
  beforeMount() {

  },
  created() {
  },
  setup(props, context) {

    const selected = ref(null);
    const submitting = ref(false);
    const confirmModal = ref(false);
    const removeClicked = (user) => {
      selected.value = user;
      confirmModal.value = true;
    }

    const confirmDelete = () => {
      submitting.value = true;
      confirmModal.value = false;

      axios
          .post(route("billing.usage.delete"), {
            user_id: selected.value.id
          })
          .then((response) => {
            submitting.value = false;
            message.success('Successfully removed', 5);
            window.location.reload();
          })
          .catch((error) => {
            submitting.value = false;
            console.log(error);
            message.error('Our system cannot delete it, please contact us.', 5);
          });
    }
    return {
      confirmDelete,
      submitting,
      removeClicked,
      confirmModal,
      pages
    }
  },

  methods: {},
  components: {
    UpdateBillingForm,
    NoData,
    JetConfirmationModal,
    JetDangerButton,
    JetSecondaryButton,
    MailIcon,
    UsersIcon,
    BreadNav,
    AppLayout,
  },
};
</script>
